export const TELESRV_NAME = 'Telesrv';
export const TELESRV_WEB_K_NAME = 'Telesrv Web K';
export const TELESRV_SCHEME = 'telesrv';
export const TELESRV_PUBLIC_HOST = 'telesrv.net';
export const TELESRV_PUBLIC_URL = `https://${TELESRV_PUBLIC_HOST}`;
export const TELESRV_WEB_A_URL = 'https://web.telesrv.net/';
export const TELESRV_WEB_K_URL = 'https://webk.telesrv.net/';
export const TELESRV_WEB_DOMAINS = ['web.telesrv.net', 'webk.telesrv.net'];
